/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { NOT_FOUND } from '@jira/platform__http-status-codes/src/http-status-codes.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { DismissData } from '@jira/automation__automation-discoverability/src/common/types.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const PROPERTY_KEY = 'jira.user.issue.automation-discoverability.panel.state';

export const getAutomationDiscoveryDismissResource: RouteResource<DismissData> =
	createResource<DismissData>({
		type: 'getAutomationDiscoveryDismiss',
		getKey: () => 'getAutomationDiscoveryDismiss',
		getData: async (): Promise<DismissData> => {
			try {
				const res = await performGetRequest(`/rest/api/3/mypreferences?key=${PROPERTY_KEY}`);
				return res;
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				if (error.statusCode === NOT_FOUND) {
					return null;
				}
				fireErrorAnalytics({
					error,
					meta: {
						id: 'getDismissData',
						teamName: 'ITOps Phantom',
						packageName: 'jiraEocAutomationDiscovery',
					},
				});
				throw error;
			}
		},
		maxAge: 5 * 60 * 1000,
	});
